<template>
  <div class="flow-wrap">
    <el-row>
      <el-col :span="24">流程名称</el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col
        v-for="(item,index) of list"
        :xs="24"
        :sm="6"
        :md="6"
        :lg="6"
        :span="6"
        :key="index">
        <div class="audit-content-box">
          <div class="audit-info">
            <div class="ellipsis">
              <i class="el-icon-menu"></i>
              {{item.nodeName}}
            </div>
            <div class="ellipsis">
              <i class="el-icon-user-solid"></i>
              {{item.name}}
            </div>
          </div>
          <div class="right-icon">
            <i v-if="index !== list.length -1" class="el-icon-d-arrow-right"></i>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import 'element-ui/lib/theme-chalk/display.css';

  export default {
    name: "TableForm",
    components: {},
    directives: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
      return {
        labelWidthCup: '120px',
        label: '姓名姓名姓姓姓名姓名姓名姓名',
        list: [
          {
            nodeName: '开始',
            name: '张三 李四 李四 李四 李四 李四',
          },
          {
            nodeName: '区域公司开始开始开始开始开始',
            name: '李四 李四 李四 李四 李四 李四 李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '区域公司',
            name: '李四',
          },
          {
            nodeName: '总经理',
            name: '王五',
          },
        ],
        ellipsisList: []
      }
    },
    watch: {},
    methods: {
      itemHeightStyle(item) {
        if (item.minHeight) {
          return {minHeight: item.minHeight}
        }
        return {height: item.height ? item.height : '60px'}
      },
      contentStyle(item) {
        if (!item.minHeight) {
          return {
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'display': '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical'
          }
        }
      },
      componentDidMount(refName) {
        if (!refName) return
        this.$nextTick(() => {
          const node = this.$refs[refName] ? this.$refs[refName][0] : null
          const clientWidth = node.clientWidth
          const scrollWidth = node.scrollWidth
          if (clientWidth < scrollWidth) {
            if (this.ellipsisList.indexOf(refName) === -1) {
              this.ellipsisList.push(refName)
            }
          }
        });
      },
      disabledTools(item) {
        if (item.minHeight) {
          return true
        } else if (!this.value[item.prop]) {
          return true
        } else if (this.ellipsisList.includes(item.prop)) {
          return true
        }
      }
    }
  }
</script>

<style scoped>

  .flow-wrap {
    --border-color: #BFE7E7;
    margin: 30px;
    line-height: 1.4;
    box-sizing: border-box;
    color: #333;
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    background: #fff;
    padding: 20px;
  }
  .flow-wrap .audit-content-box {
    margin: 20px 0;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .flow-wrap .audit-content-box .audit-info {
   padding: 20px;
    background: #f8f8f8;
    flex: 1;
    border-radius: 6px;
  }
  .flow-wrap .audit-content-box .audit-info .ellipsis {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical
  }
  .flow-wrap .audit-content-box .right-icon {
    width: 40px;
    margin-left: auto;
    text-align: right;
    font-size: 20px;
    color: #999988;
  }
</style>
